(function () {
  class Jq65pEmsTabs extends HTMLElement {
    connectedCallback() {
      if (this.inited) return;
      this.inited = true;
      this.init();
    }

    disconnectedCallback() {
      this.destroy();
      this.inited = false;
    }

    init() {
      if (typeof Swiper === "undefined") {
        this.retry_count = (this.retry_count || 0) + 1;
        if (this.retry_count > 20) return;
        this.retry_timer = setTimeout(() => this.init(), 120);
        return;
      }

      this.swiper_el = this.querySelector("[data-jet-swiper]");
      this.tabs = Array.from(this.querySelectorAll("[data-jet-tab]"));
      if (!this.swiper_el || this.tabs.length === 0) return;

      const reduce_motion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const enable_autoplay = this.dataset.autoplay === "true";
      const autoplay_delay = Math.max(1, Number(this.dataset.autoplayDelay || 4)) * 1000;

      this.autoplay_enabled = enable_autoplay && !reduce_motion && this.tabs.length > 1;

      this.swiper = new Swiper(this.swiper_el, {
        effect: "fade",
        fadeEffect: { crossFade: true },
        slidesPerView: 1,
        spaceBetween: 0,
        speed: reduce_motion ? 0 : 400,
        loop: this.autoplay_enabled,
        allowTouchMove: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoplay: this.autoplay_enabled
          ? {
              delay: autoplay_delay,
              disableOnInteraction: false,
              pauseOnMouseEnter: true
            }
          : false,
        on: {
          init: (swiper) => {
            this.sync_tabs(swiper.realIndex);
          },
          slideChange: (swiper) => {
            this.sync_tabs(swiper.realIndex);
          }
        }
      });

      this.on_click = (event) => {
        const tab = event.target.closest("[data-jet-tab]");
        if (!tab || !this.contains(tab)) return;

        const index = Number(tab.getAttribute("data-jet-tab"));
        if (!Number.isFinite(index)) return;

        this.go_to_slide(index);
      };

      this.addEventListener("click", this.on_click);
      this.bind_visibility();
    }

    go_to_slide(index) {
      if (!this.swiper) return;

      if (this.autoplay_enabled && typeof this.swiper.slideToLoop === "function") {
        this.swiper.slideToLoop(index);
      } else {
        this.swiper.slideTo(index);
      }

      this.sync_tabs(index);

      if (
        this.autoplay_enabled &&
        this.swiper.autoplay &&
        typeof this.swiper.autoplay.start === "function"
      ) {
        this.swiper.autoplay.start();
      }
    }

    sync_tabs(index) {
      this.tabs.forEach((tab) => {
        const is_active = Number(tab.getAttribute("data-jet-tab")) === index;
        tab.classList.toggle("is-active", is_active);
        tab.setAttribute("aria-selected", is_active ? "true" : "false");
      });
    }

    bind_visibility() {
      if (!this.autoplay_enabled || !this.swiper || !this.swiper.autoplay) return;
      if (typeof IntersectionObserver === "undefined") return;

      this.io = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (!this.swiper || !this.swiper.autoplay) return;
          if (entry.isIntersecting) {
            this.swiper.autoplay.start();
          } else {
            this.swiper.autoplay.stop();
          }
        },
        { threshold: 0.25 }
      );
      this.io.observe(this);
    }

    destroy() {
      if (this.retry_timer) {
        clearTimeout(this.retry_timer);
        this.retry_timer = null;
      }

      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }

      if (this.on_click) {
        this.removeEventListener("click", this.on_click);
        this.on_click = null;
      }

      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  function mount_jq65p_ems_tabs(root) {
    if (!root) return;
    const panels = root.matches("jq65p-ems-tabs")
      ? [root]
      : Array.from(root.querySelectorAll("jq65p-ems-tabs"));

    panels.forEach((panel) => {
      if (panel.inited) {
        panel.disconnectedCallback();
        panel.connectedCallback();
      }
    });
  }

  if (!customElements.get("jq65p-ems-tabs")) {
    customElements.define("jq65p-ems-tabs", Jq65pEmsTabs);
  }

  document.addEventListener("shopify:section:load", (event) => {
    mount_jq65p_ems_tabs(event.target);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const panel = event.target.closest("jq65p-ems-tabs");
    if (!panel || !panel.swiper) return;

    const tab = event.target.closest("[data-jet-tab]");
    const slide = event.target.closest(".jq65p-ems__slide");
    let index = -1;

    if (tab) {
      index = Number(tab.getAttribute("data-jet-tab"));
    } else if (slide) {
      const slides = Array.from(
        panel.querySelectorAll(".jq65p-ems__slide:not(.swiper-slide-duplicate)")
      );
      index = slides.indexOf(slide);
    }

    if (index >= 0) {
      panel.go_to_slide(index);
    }
  });
})();
